import { createStrictContext, useStrictContext } from '../react'
import { ConfirmationContextType } from './types'

export const ConfirmationContext =
  createStrictContext<ConfirmationContextType>()

export const useGetConfirmation = () => {
  const { getConfirmation } = useStrictContext(ConfirmationContext)

  return getConfirmation
}
